import { getInitialSiteGeometryStore, siteGeometryStore } from "../store";

export const resetSiteGeometryStore = () => {
  const { siteFeatures, clusters, boundsDistance, loading } = getInitialSiteGeometryStore();
  siteGeometryStore.siteFeatures = siteFeatures;
  siteGeometryStore.clusters = clusters;
  siteGeometryStore.boundsDistance = boundsDistance;
  siteGeometryStore.loading = loading;
};
